<template>
    <div></div>
</template>
<script>
    import {Dialog} from 'vant'
    export default {
        name: 'FaceResult',
        created() {
            const redirectUrl = this.$route.query.redirectPath;
            const result = this.$route.query.result;
            if (result == 1) {
                this.$router.replace(redirectUrl)
            } else {
                Dialog.alert({
                    title: '人脸识别不通过',
                    message: '很抱歉，人脸识别未通过，请在光线充足地方重新尝试',
                }).then(() => {
                    this.$router.back()
                });
            }
        }
    }
</script>